export enum PageType {
    Home = "home",
    Theme = "theme",
    SubTheme = "sub_theme",
    ProductTheme = "product_theme",
    ProductList = "product_list",
    Content = "content",
    SearchResult = "search_result",
    ProductDetail = "product_detail",
    Checkout = "checkout",
    Confirmation = "confirmation",
    Account = "account",
    Form = "form",
    Error = "error",
    Other = "other",
    Overview = "overview",
    Faq = "faq",
    Contact = "contact",
    Jobs = "jobs"
}
